import styles from './QuoteFullColour.module.css'

interface QuoteFullColourProps {
  label?: string
  text: string
}

export default function QuoteFullColour({ label = 'Growth House Mantra', text }: QuoteFullColourProps) {
  return (
    <div className={styles.block} data-testid="quote-full-colour">
      <div className={styles.label}>{label}</div>
      <div className={styles.text}>&ldquo;{text}&rdquo;</div>
    </div>
  )
}
